window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

document.body.addEventListener("click", async (event) => {
  if (!event.target.matches(".cart__remove-bundle *, .cart__remove-bundle[data-bundle-id]")) return;

  const bundleElement = event.target.closest(".cart__remove-bundle") || (event.target.hasAttribute("data-bundle-id") ? event.target : null);
  const bundle_id = bundleElement ? bundleElement.getAttribute("data-bundle-id") : null;

  if (bundle_id) {
    event.preventDefault();
    try {
      // Get current cart contents
      const cart = await (await fetch("/cart.js")).json();

      // Create data object for cart update AJAX call
      const data = {
        updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid == bundle_id ? { ...acc, [item.key]: 0 } : acc), {})
      };

      // API call to update the cart contents and set the bundle item quantities to 0
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      response.ok && (window.location.href = "/cart");
    } catch (error) {
      console.error(error);
    }
  }
});

const nextOrderWithin24h = () => {
  const nbd = window.Awtomic.subscriptionDetails.NextBillingDate;
  const nextOrderDate = new Date(nbd);
  const now = new Date();
  const timeDifference = nextOrderDate - now;

  return timeDifference > 0 && timeDifference <= 24 * 60 * 60 * 1000;
};
const disableAllEditing = () => {
  // get all awtomic buttons
  const buttons = document.querySelectorAll(
    '.bundle-action-button-container button, [class^="bundle-button"], [class^="bundle-card__button"], [class^="bundle-action-dots"], [class^="bundle-quantity-button"], [class^="bundle-product-name"], [class^="bundle-img-container"]'
  );
  // now disable all these buttons
  buttons.forEach((button) => {
    button.classList.add("disabled");
    button.setAttribute("disabled", "disabled");
    button.style.pointerEvents = "none";
    button.style.setProperty("hover", "none");
    button.onmouseover =
      button.onmouseenter =
      button.onmousemove =
        (e) => {
          e.stopPropagation();
          e.preventDefault();
        };
  });
};

const insertExplanationBanner = () => {
  // Only add the banner if it doesn't already exist
  if (document.querySelector(".awtomic-explanation-banner")) return;

  const explanationBanner = document.createElement("div");
  explanationBanner.className = "bundle-card awtomic-explanation-banner";
  explanationBanner.innerHTML = `
    <p>Editing is disabled because your next order is within 24 hours. Please wait until after your next order to make changes.</p>
  `;
  // Insert just before the first element with class 'bundle-card--next-order-date'
  const target = document.querySelector(".bundle-card--next-order-date");
  if (target && target.parentNode) {
    target.parentNode.insertBefore(explanationBanner, target);
  }
};

window.addEventListener("awtomic-cp-loaded", ({ detail } = {}) => {
  setTimeout(() => {
    if (nextOrderWithin24h()) {
      disableAllEditing();
      insertExplanationBanner();
    }
  }, 200);
  if (nextOrderWithin24h()) {
    disableAllEditing();
    insertExplanationBanner();
  }
});
